/* icon/UI 24px/Book (education, info, guide, FAQ).svg: width 24px x height 24px */
export default class DlsIconBook extends HTMLElement {
  static define(tagName = 'dls-icon-book') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M12 6.282c0-.972 1.215-2.532 5.125-2.532s5.125 2.25 5.125 3v13.836c-.585-.706-2.639-1.841-5.125-1.841S12.562 19.88 12 20.584c-.585-.705-2.639-1.84-5.125-1.84s-4.563 1.135-5.125 1.84V6.75c0-.75 1.215-3 5.125-3S12 5.31 12 6.282v14.304"/></svg>`;
  }
}
DlsIconBook.define();
